import { Drawer, Portal, Stack, Link as ChakraLink, CloseButton, Box } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useMenu } from '@/hooks/use-menu.tsx';

export default function MobileNavDrawer() {
  const { isOpen, onClose } = useMenu();

  return (
    <Drawer.Root open={isOpen} size='sm' onOpenChange={onClose} placement='end'>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.Header>
              <Drawer.CloseTrigger asChild>
                <CloseButton size='md' />
              </Drawer.CloseTrigger>
              <Drawer.Title>Menu</Drawer.Title>
            </Drawer.Header>
            <Drawer.Body>
              <Stack gap='4'>
                <ChakraLink fontSize='md' asChild>
                  <Link to='/map' onClick={onClose}>
                    Map
                  </Link>
                </ChakraLink>
                <ChakraLink fontSize='md' asChild>
                  <Link
                    to='https://mapper.sksis.ca/users/sign_in'
                    target='_blank'
                    onClick={onClose}
                  >
                    SKSIS Mapper
                  </Link>
                </ChakraLink>
                <ChakraLink fontSize='md' asChild>
                  <Link to='/data-download' onClick={onClose}>
                    Data Download
                  </Link>
                </ChakraLink>
                <ChakraLink fontSize='md' asChild>
                  <Link to='/documentation' onClick={onClose}>
                    Documentation
                  </Link>
                </ChakraLink>
                <ChakraLink fontSize='md' asChild>
                  <Link to='/cpssl' onClick={onClose}>
                    CPSSL
                  </Link>
                </ChakraLink>
                <ChakraLink fontSize='md' asChild>
                  <Link to='/contact' onClick={onClose}>
                    Contact
                  </Link>
                </ChakraLink>
                <ChakraLink fontSize='md' asChild>
                  <Link to='/acknowledgments' onClick={onClose}>
                    Acknowledgments
                  </Link>
                </ChakraLink>
                <ChakraLink fontSize='md' asChild>
                  <Link to='/citation' onClick={onClose}>
                    Citation
                  </Link>
                </ChakraLink>
                <Box borderTop='1px solid' borderColor='bg.muted' pt='4' mt='4'>
                  <ChakraLink fontSize='md' asChild>
                    <Link to='https://app.sksis.ca' target='_blank' onClick={onClose}>
                      Switch to Previous Version
                    </Link>
                  </ChakraLink>
                </Box>
              </Stack>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}
